import { render, staticRenderFns } from "./order_transfer_purchase.vue?vue&type=template&id=f59375ac&scoped=true"
import script from "./order_transfer_purchase.vue?vue&type=script&lang=js"
export * from "./order_transfer_purchase.vue?vue&type=script&lang=js"
import style0 from "./order_transfer_purchase.vue?vue&type=style&index=0&id=f59375ac&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f59375ac",
  null
  
)

export default component.exports